import React from "react";
import { useFormik } from "formik";
import {
  IWorkFlowAction,
  IWorkFlowCondition,
} from "../../../redux/automation/automation.types";
import { Box, Button, Grid, Stack } from "@mui/material";
import { Save } from "@mui/icons-material";

import { IActionNodeRightPanelProps } from "./ActionNodeRightPanel.types";
import { upsertActionNode } from "../../../redux/automation";
import { RightPanel } from "../../../Components/RightPanel";
import {
  ControlledCustomSelect,
  CustomFormLabel,
  CustomTextField,
} from "../../../Components/formComponents";
import { useAppDispatch } from "../../../redux";
import { useOutletContext } from "../../../providers";

export const ActionNodeRightPanel: React.FC<IActionNodeRightPanelProps> = (
  props
) => {
  const { open, nodeData, onClose } = props;

  const dispatch = useAppDispatch();
  const {
    outlet_details: { outlet_uuid, outlet_name },
  } = useOutletContext();

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setValues,
    setFieldValue,
  } = useFormik<IWorkFlowAction>({
    initialValues: nodeData,
    validate: (values) => {
      const errors: any = {};
      if (!values.action_type) {
        errors.action_type = "Action type field is required"!;
      }

      return errors;
    },
    onSubmit: (values) => {
      dispatch(
        upsertActionNode({
          payload: {
            ...values,
            outlet_uuid: outlet_uuid,
            outlet_name: outlet_name,
          },
          onCallback(isSuccess) {
            if (isSuccess) {
              onClose();
            }
          },
        })
      );
    },
  });

  const handlePreventEventBubbling = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  return (
    <RightPanel
      open={open}
      heading="Create Action"
      onClose={onClose}
      isWrappedWithForm
      onFormSubmit={handleSubmit}
      actionButtons={() => {
        return (
          <Stack
            spacing={2}
            direction={"row"}
            onClick={handlePreventEventBubbling}
          >
            <Button
              variant="contained"
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              type="submit"
              // disabled={loading}
              startIcon={<Save />}
            >
              Save
            </Button>
          </Stack>
        );
      }}
    >
      <Box onClick={handlePreventEventBubbling}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid item xs={12}>
              <CustomFormLabel>Action Code</CustomFormLabel>
              <CustomTextField
                fullWidth
                value={values.workflow_action_code}
                disabled
              />
            </Grid>
            <CustomFormLabel>Action Type</CustomFormLabel>
            <ControlledCustomSelect
              name="action_type"
              fullWidth
              value={values.action_type}
              disabled
              options={[
                { label: "Email", value: "EMAIL" },
                { label: "SMS", value: "SMS" },
                { label: "WhatsApp", value: "WHATSAPP" },
                { label: "Modification", value: "MODIFICATION" },
              ]}
              error={errors.action_type}
              displayEmpty
              placeholder="Select one"
            />
          </Grid>
          <Grid item xs={12}>
            <CustomFormLabel>Comment</CustomFormLabel>
            <CustomTextField
              id="comment"
              fullWidth
              value={values.comment}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Box>
    </RightPanel>
  );
};
